// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"132":"8720c924d681b390","754":"036d5d51908dfa9a","922":"28013e1552102135"}[chunkId] + ".js";
};